import { correctNode } from './correctFocus.js';

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, node) {
    return nodes.indexOf(correctNode(node, nodes));
};

export { pickFirstFocus, pickFocusable };
//# sourceMappingURL=firstFocus.js.map
